// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { K8sIoApiCoreV1ConditionStatus } from './K8sIoApiCoreV1ConditionStatus';
import {
  K8sIoApiCoreV1ConditionStatusFromJSON,
  K8sIoApiCoreV1ConditionStatusFromJSONTyped,
  K8sIoApiCoreV1ConditionStatusToJSON,
  K8sIoApiCoreV1ConditionStatusToJSONTyped,
} from './K8sIoApiCoreV1ConditionStatus';
import type { V1Neo4jDatabaseConditionType } from './V1Neo4jDatabaseConditionType';
import {
  V1Neo4jDatabaseConditionTypeFromJSON,
  V1Neo4jDatabaseConditionTypeFromJSONTyped,
  V1Neo4jDatabaseConditionTypeToJSON,
  V1Neo4jDatabaseConditionTypeToJSONTyped,
} from './V1Neo4jDatabaseConditionType';

/**
 *
 * @export
 * @interface V1Neo4jDatabaseCondition
 */
export interface V1Neo4jDatabaseCondition {
  /**
   * Last time the condition transitioned from one status to another.
   * @type {string}
   * @memberof V1Neo4jDatabaseCondition
   */
  lastTransitionTime?: string;
  /**
   * The last time this condition was updated.
   * @type {string}
   * @memberof V1Neo4jDatabaseCondition
   */
  lastUpdateTime?: string;
  /**
   * A human-readable message indicating details about the transition.
   * @type {string}
   * @memberof V1Neo4jDatabaseCondition
   */
  message?: string;
  /**
   * The reason for the condition's last transition.
   * @type {string}
   * @memberof V1Neo4jDatabaseCondition
   */
  reason?: string;
  /**
   * Status of the condition, one of True, False, Unknown.
   * @type {K8sIoApiCoreV1ConditionStatus}
   * @memberof V1Neo4jDatabaseCondition
   */
  status?: K8sIoApiCoreV1ConditionStatus;
  /**
   * Type of deployment condition.
   * @type {V1Neo4jDatabaseConditionType}
   * @memberof V1Neo4jDatabaseCondition
   */
  type?: V1Neo4jDatabaseConditionType;
}

/**
 * Check if a given object implements the V1Neo4jDatabaseCondition interface.
 */
export function instanceOfV1Neo4jDatabaseCondition(
  value: object,
): value is V1Neo4jDatabaseCondition {
  return true;
}

export function V1Neo4jDatabaseConditionFromJSON(
  json: any,
): V1Neo4jDatabaseCondition {
  return V1Neo4jDatabaseConditionFromJSONTyped(json, false);
}

export function V1Neo4jDatabaseConditionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1Neo4jDatabaseCondition {
  if (json == null) {
    return json;
  }
  return {
    lastTransitionTime:
      json['lastTransitionTime'] == null
        ? undefined
        : json['lastTransitionTime'],
    lastUpdateTime:
      json['lastUpdateTime'] == null ? undefined : json['lastUpdateTime'],
    message: json['message'] == null ? undefined : json['message'],
    reason: json['reason'] == null ? undefined : json['reason'],
    status:
      json['status'] == null
        ? undefined
        : K8sIoApiCoreV1ConditionStatusFromJSON(json['status']),
    type:
      json['type'] == null
        ? undefined
        : V1Neo4jDatabaseConditionTypeFromJSON(json['type']),
  };
}

export function V1Neo4jDatabaseConditionToJSON(
  json: any,
): V1Neo4jDatabaseCondition {
  return V1Neo4jDatabaseConditionToJSONTyped(json, false);
}

export function V1Neo4jDatabaseConditionToJSONTyped(
  value?: V1Neo4jDatabaseCondition | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    lastTransitionTime: value['lastTransitionTime'],
    lastUpdateTime: value['lastUpdateTime'],
    message: value['message'],
    reason: value['reason'],
    status: K8sIoApiCoreV1ConditionStatusToJSON(value['status']),
    type: V1Neo4jDatabaseConditionTypeToJSON(value['type']),
  };
}
